module.exports = __webpack_public_path__ + "img/sweden_ru.7f42eba1.png";